/**
 * Attempts to extract useful but safe properties from an axios error
 * @param  {object} error - The error object to introspect
 */
const extractAxiosError = error => {
    if (error && error.response && error.config) {
        try {
            return {
                endpointStatusCode: error.response.status,
                endpointErrorMessage: error.toJSON().message,
                endpointUri: error.response.config.url,
                endpointMethod: error.response.config.method,
                endpointSuppliedAuthToken: error.config.headers.Authorization !== undefined
            };
        } catch {
            return {};
        }
    }

    return {};
};

/**
 * Adds key properties we need for every log message
 * @param  {object} logPayload - An object containing properties you want to log
 * @param  {string} message - Describe what happened
 * @param  {string} level - Was this an error, warn or info
 * @param  {string} mode - Did this happen server or client side
 * @param  {string|string[]} tags - List of tags so logs can be connected to a team / feature
 */
const appendStandardProperties = (logPayload, message, level, mode, tags) => {
    let tagsArr = [];
    if (tags) { tagsArr = Array.isArray(tags) ? tags : [tags]; }

    logPayload.message = message || 'No message provided';
    logPayload.Level = level || 'error'; // Intentionally uppercased property
    logPayload.mode = mode || '';
    logPayload.tags = tagsArr;
};

/**
 * Attempts to add useful diagnostic detail to the payload
 * @param  {object} logPayload - An object containing properties you want to log
 * @param  {object} store - The VUEX store from context or this, provide it when you can
 */
const appendBasePayload = (logPayload, store) => {
    if (store) {
        const { logBasePayload } = store.state.logging;

        return {
            ...logBasePayload,
            ...logPayload
        };
    }

    return logPayload || {};
};

export {
    extractAxiosError,
    appendStandardProperties,
    appendBasePayload
};
